import { useEffect, useState } from "react";
import axios from "axios";
import { setToken, setUserData } from "../redux/main/action/main";
import { formatUserData } from "../utility/helper";
import { getProfileData } from "../redux/profile/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import styles from "../styles/pages/TokenExpired.module.css";
import logo from "../asset/Images/cryptocrispyLogo.png";
import MiniAppLoginPage from "../components/mini-app/auth/MiniAppLoginPage";

const readStoredJson = (storage, key) => {
  try {
    const value = storage?.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    return null;
  }
};

function TokenExpired() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");

  const telegramData = localStorage.getItem("telegramData") || "";
  const telegram_id = telegramData ? telegramData.slice(0, 20) : "";
  const user = telegramData ? telegramData.slice(20, 25) : "";
  const email = telegramData ? telegramData.slice(25, 30) : "";
  const storedToken =
    readStoredJson(localStorage, "aws-amplify-federatedInfo")?.token ||
    readStoredJson(sessionStorage, "aws-amplify-federatedInfo")?.token;

  const urlString = localStorage.getItem("prevPath") || "";
  const parts = urlString.split("*");
  const path = parts.length > 1 ? parts[1] : "";

  const checkAuthentication = async () => {
    if (error) setError("");
    setStatus("loading");
    await axios
      .post(
        "https://0znr1xesf9.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        {
          operation_mode: "login",
          telegram_id,
          email,
          user,
        },
      )
      .then((res) => {
        const {
          accessToken: { jwtToken, payload },
        } = res?.data;
        setStatus("done");
        // console.log(res?.data);
        dispatch(setToken(jwtToken));
        dispatch(setUserData(formatUserData(res?.data?.accessToken)));
        axios.defaults.headers.common["Authorization"] = `${jwtToken}`;
        dispatch(
          getProfileData(payload?.email, payload["custom:custom_username"]),
        );

        localStorage.setItem("telegramData", telegramData);
        if (path) {
          navigate(path);
        } else {
          navigate("/dashboard");
        }
      })
      .catch((err) => {
        setStatus("error");
        setError(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (storedToken) {
      navigate("/", { replace: true });
      return;
    }

    if (telegram_id && telegram_id !== "null") {
      checkAuthentication();
    } else {
      navigate("/telegram-authentication", { replace: true });
    }
  }, [navigate, storedToken, telegram_id]);

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <img src={logo} alt={"logo"} />
      </div>

      {status === "loading" && (
        <div className={styles.loader}>
          <Spin />
        </div>
      )}

      {status === "error" && <MiniAppLoginPage />}
    </div>
  );
}

export default TokenExpired;
